import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const isSuspended = localStorage.getItem("isSuspended");

  if (token) return children;
  if (isSuspended) return children;

  return <Navigate to="/register" replace />;
};

export default PrivateRoute;
